// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document[data-v-593facff]{width:80%;margin:auto}@media only screen and (max-width: 599px){.document[data-v-593facff]{width:100%;margin-top:100px !important}}", ""]);
// Exports
module.exports = exports;
